export const blockIconsHardwareVideogameAssetNew = (
	<span className='material-symbols-outlined'>videogame_asset</span>
);
